import MainLayout from '../layouts/main';

function DefaultPage() {
  return <MainLayout loginRequired={false} studentRequired={false} />;
}

export default DefaultPage;
